export const CA_CERTIFICATE_FIELDS: readonly string[] = [
  "caCertificate",
  "tlsCaCertificate",
];

export const INVALID_CA_CERTIFICATE_MESSAGE =
  "Upload a valid PEM (Base-64 encoded X.509) certificate. Binary DER certificates aren’t supported.";

export function certificatePemBlocks(value: string): string[] | null {
  const begin = "-----BEGIN CERTIFICATE-----";
  const end = "-----END CERTIFICATE-----";
  if (/-----BEGIN (?!CERTIFICATE-----)/.test(value)) return null;
  const [, ...parts] = value.split(begin);
  if (parts.length === 0) return null;
  const certificates: string[] = [];
  for (const part of parts) {
    const endIndex = part.indexOf(end);
    if (endIndex === -1) return null;
    certificates.push(`${begin}${part.slice(0, endIndex + end.length)}`);
  }
  return certificates;
}
